import axios from "axios"
import React, { useEffect, useRef, useState } from "react"
import MultipleValueTextInput from "react-multivalue-text-input"
import { useHistory } from "react-router-dom"
import { Col, Input, Row } from "reactstrap"
import Select from "react-select"
import DatePicker from "react-datepicker"

const FilterProjects = ({
  filteredValues,
  setFilteredValues,
  categories,
  setCategories,
  stages,
  setStages,
  setAuth,
}) => {
  const history = useHistory()

  const debounceTimeout = useRef(null)

  const formData = {
    PerToken: localStorage.getItem("token"),
    PerUserID: localStorage.getItem("id"),
    PerRoleID: localStorage.getItem("userRoleID"),
  }

  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
    }
    axios
      .post(process.env.REACT_APP_API_URL + "api/OpenAccess/TypeList", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        let data = Object.entries(res.data)
        // console.log("data", data)
        setCategories(data.map(item => item[1]))
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  // console.log("stages", stages)
  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
    }
    axios
      .post(process.env.REACT_APP_API_URL + "api/Stages/View", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        let array = Object.entries(res.data)
        array.splice(-1)
        setStages(array.map(item => item[1].StageName))
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  const filteredFeatures = [
    "Category",
    "Reference No.",
    "Request No.",
    "Policy No.",
    "Areal Decision No.",
    "Date",
    "Type",
    "Payment",
    "RD0Status",
    // "InsStages"
    "SP",
    "MS",
  ]
  const statusOptions = [
    "Pending",
    "Approved",
    "Rejected",
    "Manual",
    "Out_Of_RDAPP",
    "Missing Data",
    "Manger Approval",
    "Under Review",
    "Edit Required",
    "InProgress",
  ]
  const InsStage = [
    "Pending",
    "Approved",
    "Rejected",
    "Manual",
    "Out_Of_RDAPP",
    "Missing Data",
    "Manger Approval",
    "Under Review",
    "Edit Required",
    "InProgress",
  ]

  const [ref, setRef] = useState(filteredValues.ReferenceNo)

  // ********************** Date Range ***************************
  const [dateRange, setDateRange] = useState([null, null])
  const [startDate, endDate] = dateRange

  const convertDate = value => {
    let day = value.getDate() + ""
    day = day.length === 1 ? `0${day}` : day
    let month = value.getMonth() + 1 + ""
    month = month.length === 1 ? `0${month}` : month
    let year = value.getFullYear()
    return `${year}-${month}-${day}` || null
  }

  return (
    <>
      <Row>
        <Col sm={3}>
          {/* ******************************* Reference No *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              {/* <MultipleValueTextInput
                style={{ width: "150%" }}
                onItemAdded={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    ReferenceNo: allItems,
                  })
                }
                onItemDeleted={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    ReferenceNo: allItems,
                  })
                }
                type="number"
                name="ReferenceNo"
                placeholder="Reference No ..."
                className="border-0 mt-1"
              /> */}

              <Input
                type="number"
                className="border-0 px-0 mx-0"
                placeholder="Reference No"
                onChange={e => {
                  setRef(e.target.value)
                  if (e.target.value.length > 3) {
                    setFilteredValues(prev => ({
                      ...prev,
                      ReferenceNo: e.target.value,
                    }))
                  } else if (
                    e.target.value.length <= 3 &&
                    filteredValues.ReferenceNo
                  ) {
                    setFilteredValues(prev => ({
                      ...prev,
                      ReferenceNo: "",
                    }))
                  }
                }}
              />
            </div>
          </div>

          {/* ******************************* Policy No *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <MultipleValueTextInput
                style={{ width: "150%" }}
                onItemAdded={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    PolicyNo: allItems,
                  })
                }
                onItemDeleted={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    PolicyNo: allItems,
                  })
                }
                type="number"
                name="PolicyNo"
                placeholder="Policy No ..."
                className="border-0 mt-1"
              />
            </div>
          </div>

          {/* ******************************* Category *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />

              <Input
                type="select"
                name="Category"
                style={{ border: "none" }}
                onChange={e => {
                  // console.log(e.target.value)
                  setFilteredValues({
                    ...filteredValues,
                    Category: e.target.value,
                  })
                }}
              >
                <option selected value="">
                  Category...
                </option>
                {categories.map((item, i) => (
                  <option key={i} value={item.BCID}>
                    {item.Name}
                  </option>
                ))}
              </Input>
            </div>
          </div>
        </Col>

        <Col sm={3}>
          {/* ******************************* Request No *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <MultipleValueTextInput
                style={{ width: "150%" }}
                onItemAdded={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    RequestNo: allItems,
                  })
                }
                onItemDeleted={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    RequestNo: allItems,
                  })
                }
                type="number"
                name="RequestNo"
                placeholder="Request No ..."
                className="border-0 mt-1"
              />
            </div>
          </div>

          {/* ******************************* Areal Decision Number *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <MultipleValueTextInput
                style={{ width: "150%" }}
                onItemAdded={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    ArealDecisionNo: allItems,
                  })
                }
                onItemDeleted={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    ArealDecisionNo: allItems,
                  })
                }
                type="number"
                name="ArealDecisionNo"
                placeholder="Survey Resolution No ..."
                className="border-0 mt-1"
              />
            </div>
          </div>

          {/* ******************************* Classification *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <Input
                type="select"
                name="SP"
                onChange={e => {
                  // console.log(e.target.value)
                  setFilteredValues({
                    ...filteredValues,
                    SP: e.target.value,
                  })
                }}
                className="border-0"
              >
                <option selected value="">
                  Classification...
                </option>
                <option value="1">SP</option>
                <option value="0">RP</option>
              </Input>
            </div>
          </div>
        </Col>

        <Col sm={3}>
          {/* ******************************* Status *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <Input
                type="select"
                name="status"
                onChange={e => {
                  setFilteredValues({
                    ...filteredValues,
                    RD0Status: e.target.value,
                  })
                }}
                className="border-0"
              >
                <option selected value="">
                  Status...
                </option>
                {statusOptions.map((status, i) => (
                  <option key={i} value={status}>
                    {status}
                  </option>
                ))}
              </Input>
            </div>
          </div>

          {/* ******************************* Type *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <Input
                type="select"
                name="type"
                onChange={e => {
                  // console.log(e.target.value)
                  setFilteredValues({
                    ...filteredValues,
                    Type: e.target.value,
                  })
                }}
                className=" border-0"
              >
                <option selected value="">
                  Type...
                </option>
                <option value="FT">FT</option>
                <option value="NT">NT</option>
              </Input>
            </div>
          </div>

          {/* ******************************* Missing Stage *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <Input
                type="select"
                name="MS"
                onChange={e => {
                  // console.log(e.target.value)
                  setFilteredValues({
                    ...filteredValues,
                    MS: e.target.value,
                  })
                }}
                className="border-0"
              >
                <option selected value="">
                  MissingStage...
                </option>
                <option value="1">MS</option>
                <option value="0">FS</option>
              </Input>
            </div>
          </div>
        </Col>

        <Col sm={3}>
          {/* ******************************* Date *********************************** */}
          {/* <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <Input
                type="date"
                className="border-0"
                placeholder="Date ..."
                onChange={e => {
                  if (debounceTimeout.current) {
                    clearTimeout(debounceTimeout.current)
                  }

                  debounceTimeout.current = setTimeout(() => {
                    setFilteredValues(prev => ({
                      ...prev,
                      Date: e.target.value,
                    }))
                  }, 1000)
                }}
              />
            </div>
          </div> */}

          {/* ******************************* Date Range *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center">
              <i className="bx bx-search-alt search-icon" />

              <DatePicker
                isClearable
                className="border-0 my-1"
                selectsRange={true}
                dateFormat="yyyy/MM/dd"
                startDate={startDate}
                endDate={endDate}
                onChange={update => {
                  setDateRange(update)
                  setFilteredValues({
                    ...filteredValues,
                    startDate: update[0] ? convertDate(update[0]) : null,
                    endDate: update[1] ? convertDate(update[1]) : null,
                  })
                }}
                // withPortal
                placeholderText="Date Range ..."
              />
            </div>
          </div>

          {/* ******************************* Payment *********************************** */}
          <div className="search-box">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <Input
                type="select"
                name="payment"
                onChange={e => {
                  // console.log(e.target.value)
                  setFilteredValues({
                    ...filteredValues,
                    Payment: e.target.value,
                  })
                }}
                className="border-0"
              >
                <option selected value="">
                  Payment ...
                </option>

                <option value="P">Paid</option>
                <option value="N">not Paid</option>
              </Input>
            </div>
          </div>
        </Col>
      </Row>

      {/* <div className="d-flex justify-content-center flex-wrap">
        {filteredFeatures.map((feature, i) =>
          feature === "Status" ? (
            <div
              className="d-flex col-2 justify-content-start mb-2 mx-1"
              key={i}
            >
              <div className="search-box me-4 col-12 ">
                <div className="position-relative mb-2 d-flex">
                  <Input
                    type="select"
                    name="status"
                    onChange={e => {
                      // console.log(e.target.value)
                      setFilteredValues({
                        ...filteredValues,
                        Status: e.target.value,
                      })
                    }}
                    className="form-control border-dark"
                  >
                    <option selected value="">
                      Last Stage...
                    </option>
                    {stages.map((stage, i) => (
                      <option key={i} value={stage.StageName}>
                        {stage.StageName}
                      </option>
                    ))}
                  </Input>
                  <i className="bx bx-search-alt search-icon " />
                </div>
              </div>
            </div>
          ) : feature === "RD0Status" ? (
            <div className="d-flex col-2 justify-content-start mb-2 mx-1">
              <div className="search-box me-4 col-12 ">
                <div className="position-relative mb-2 d-flex">
                  <Input
                    type="select"
                    name="status"
                    onChange={e => {
                      // console.log(e.target.value)
                      setFilteredValues({
                        ...filteredValues,
                        RD0Status: e.target.value,
                      })
                    }}
                    className="form-control border-dark"
                  >
                    <option selected value="">
                      Status...
                    </option>
                    {statusOptions.map((status, i) => (
                      <option key={i} value={status}>
                        {status}
                      </option>
                    ))}
                  </Input>
                  <i className="bx bx-search-alt search-icon " />
                </div>
              </div>
            </div>
          ) : feature === "Payment" ? (
            <div className="d-flex col-2 justify-content-start mb-2 mx-1">
              <div className="search-box me-4 col-12 ">
                <div className="position-relative mb-2 d-flex">
                  <Input
                    type="select"
                    name="payment"
                    onChange={e => {
                      // console.log(e.target.value)
                      setFilteredValues({
                        ...filteredValues,
                        Payment: e.target.value,
                      })
                    }}
                    className="form-control border-dark"
                  >
                    <option selected value="">
                      Payment ...
                    </option>

                    <option value="P">Paid</option>
                    <option value="N">not Paid</option>
                  </Input>
                  <i className="bx bx-search-alt search-icon " />
                </div>
              </div>
            </div>
          ) : feature === "Category" ? (
            <div className="d-flex col-2 justify-content-start mb-2 mx-1">
              <div className="search-box me-4 col-12 ">
                <div className="position-relative mb-2 d-flex col-12">
                  <input
                    list="categoriesList"
                    placeholder="Category..."
                    name="category"
                    onChange={e => {
                      setFilteredValues({
                        ...filteredValues,
                        Category: e.target.value,
                      })
                    }}
                    className="form-control border-dark"
                  />
                  <datalist id="categoriesList">
                    {categories.map((category, i) => (
                      <option key={i} value={category.Name} />
                    ))}
                  </datalist>
                  <i className="bx bx-search-alt search-icon " />
                </div>
              </div>
            </div>
          ) : feature === "SP" ? (
            <div className="d-flex col-2 justify-content-start mb-2 mx-1">
              <div className="search-box me-4 col-12 ">
                <div className="position-relative mb-2 d-flex">
                  <Input
                    type="select"
                    name="SP"
                    onChange={e => {
                      // console.log(e.target.value)
                      setFilteredValues({
                        ...filteredValues,
                        SP: e.target.value,
                      })
                    }}
                    className="form-control border-dark"
                  >
                    <option selected value="">
                      Classification...
                    </option>
                    <option value="1">SP</option>
                    <option value="0">RP</option>
                  </Input>
                  <i className="bx bx-search-alt search-icon " />
                </div>
              </div>
            </div>
          ) : feature === "MS" ? (
            <div className="d-flex col-2 justify-content-start mb-2 mx-1">
              <div className="search-box me-4 col-12 ">
                <div className="position-relative mb-2 d-flex">
                  <Input
                    type="select"
                    name="MS"
                    onChange={e => {
                      // console.log(e.target.value)
                      setFilteredValues({
                        ...filteredValues,
                        MS: e.target.value,
                      })
                    }}
                    className="form-control border-dark"
                  >
                    <option selected value="">
                      MissingStage...
                    </option>
                    <option value="1">MS</option>
                    <option value="0">FS</option>
                  </Input>
                  <i className="bx bx-search-alt search-icon " />
                </div>
              </div>
            </div>
          ) : feature === "Type" ? (
            <div className="d-flex col-2 justify-content-start mb-2 mx-1">
              <div className="search-box me-4 col-12 ">
                <div className="position-relative mb-2 d-flex">
                  <Input
                    type="select"
                    name="type"
                    onChange={e => {
                      // console.log(e.target.value)
                      setFilteredValues({
                        ...filteredValues,
                        Type: e.target.value,
                      })
                    }}
                    className="form-control border-dark"
                  >
                    <option selected value="">
                      Type...
                    </option>
                    <option value="FT">FT</option>
                    <option value="NT">NT</option>
                  </Input>
                  <i className="bx bx-search-alt search-icon " />
                </div>
              </div>
            </div>
          ) : feature === "Request No." ? (
            <div className="d-flex col-2 justify-content-start mb-2 mx-1">
              <div className="search-box me-3 col-12">
                <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
                  <i className="bx bx-search-alt search-icon" />
                  <MultipleValueTextInput
                    onItemAdded={(item, allItems) =>
                      setFilteredValues({
                        ...filteredValues,
                        RequestNo: allItems,
                      })
                    }
                    onItemDeleted={(item, allItems) =>
                      setFilteredValues({
                        ...filteredValues,
                        RequestNo: allItems,
                      })
                    }
                    type="number"
                    name="requestNo"
                    placeholder="Request No ..."
                    className="border-0 mt-1"
                  />
                </div>
              </div>
            </div>
          ) : feature === "Policy No." ? (
            <div className="d-flex col-2 justify-content-start mb-2 mx-1">
              <div className="search-box me-3 col-12">
                <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
                  <i className="bx bx-search-alt search-icon" />
                  <MultipleValueTextInput
                    onItemAdded={(item, allItems) =>
                      setFilteredValues({
                        ...filteredValues,
                        PolicyNo: allItems,
                      })
                    }
                    onItemDeleted={(item, allItems) =>
                      setFilteredValues({
                        ...filteredValues,
                        PolicyNo: allItems,
                      })
                    }
                    type="number"
                    name="policyNo"
                    placeholder="Policy No ..."
                    className="border-0 mt-1"
                  />
                </div>
              </div>
            </div>
          ) : feature === "Areal Decision No." ? (
            <div className="d-flex col-2 justify-content-start mb-2 mx-1">
              <div className="search-box me-3 col-12">
                <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
                  <i className="bx bx-search-alt search-icon" />
                  <MultipleValueTextInput
                    onItemAdded={(item, allItems) =>
                      setFilteredValues({
                        ...filteredValues,
                        ArealDecisionNo: allItems,
                      })
                    }
                    onItemDeleted={(item, allItems) =>
                      setFilteredValues({
                        ...filteredValues,
                        ArealDecisionNo: allItems,
                      })
                    }
                    type="number"
                    name="arealDecisionNo"
                    placeholder="Areal Decision No ..."
                    className="border-0 mt-1"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div
              key={i}
              className="d-flex col-2 justify-content-start mb-2 mx-1"
            >
              <div className="search-box me-4 col-12 ">
                <div className="position-relative mb-2 d-flex">
                  <Input
                    type={
                      feature === "Reference No."
                        ? "number"
                        : feature === "Date"
                        ? "date"
                        : "text"
                    }
                    className="form-control border-dark"
                    placeholder={feature}
                    onChange={e => {
                      const value = e.target.value

                      if (debounceTimeout.current) {
                        clearTimeout(debounceTimeout.current)
                      }

                      debounceTimeout.current = setTimeout(() => {
                        let updatedObject = {}

                        if (feature === "Reference No.") {
                          updatedObject["ReferenceNo"] = value
                        } else {
                          updatedObject[feature] = value
                        }

                        setFilteredValues(prev => ({
                          ...prev,
                          ...updatedObject,
                        }))
                      }, 1000)
                    }}
                  />
                  <i className="bx bx-search-alt search-icon " />
                </div>
              </div>
            </div>
          )
        )}
      </div> */}
    </>
  )
}

export default FilterProjects
